import { render, staticRenderFns } from "./PeopleSection.vue?vue&type=template&id=53811c60&scoped=true"
import script from "./PeopleSection.vue?vue&type=script&lang=js"
export * from "./PeopleSection.vue?vue&type=script&lang=js"
import style0 from "./PeopleSection.vue?vue&type=style&index=0&id=53811c60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53811c60",
  null
  
)

export default component.exports